<script lang="ts">
  import { layout, setView, type View } from '../state/layout.svelte'
  import Icon, { type IconName } from './Icon.svelte'
  import { haptic } from '../native'

  /**
   * The phone's sections (Phase 11 plan §5.2): five items, icon over label,
   * the chosen one inverted ink — never a hue, because colour in the chrome
   * means weather. 64 px plus the home indicator's inset, which it owns.
   * A tap replaces `?view=` rather than pushing history, so back does not
   * walk through tabs (§2.2).
   */

  const ITEMS: { view: View; label: string; icon: IconName }[] = [
    { view: 'forecast', label: 'Forecast', icon: 'cloud-sun' },
    { view: 'map', label: 'Map', icon: 'map' },
    { view: 'models', label: 'Models', icon: 'chart-line' },
    { view: 'places', label: 'Places', icon: 'star' },
    { view: 'settings', label: 'Settings', icon: 'settings-2' },
  ]
</script>

<nav class="nav" aria-label="Sections">
  {#each ITEMS as item (item.view)}
    <button
      type="button"
      class="touch-target"
      aria-current={layout.view === item.view ? 'page' : undefined}
      onclick={() => {
        if (layout.view !== item.view) haptic('selection')
        setView(item.view)
      }}
    >
      <Icon name={item.icon} size={22} />
      <span>{item.label}</span>
    </button>
  {/each}
</nav>

<style>
  .nav {
    flex: none;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 4px;
    height: calc(64px + var(--safe-bottom));
    padding: 6px 6px calc(6px + var(--safe-bottom));
    border-top: 1px solid var(--color-divider);
    background: var(--color-bg);
    box-shadow: var(--float-shadow);
    position: relative;
    z-index: 30;
  }

  button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    min-width: 0;
    padding: 0;
    border: 0;
    background: none;
    color: var(--color-text);
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
  }

  button[aria-current='page'] {
    background: var(--color-text);
    color: var(--color-bg);
    font-weight: 800;
  }
</style>
